/** Firestore writeBatch limiti. */
export const FIRESTORE_BATCH_LIMIT = 500;

/** Transaction silme chunk — 500 yazma limitine pay bırakır. */
export const FIRESTORE_TXN_DELETE_CHUNK = 450;

/** UID migrasyonu batch chunk. */
export const FIRESTORE_MIGRATION_BATCH = 400;
